import { render, staticRenderFns } from "./App.vue?vue&type=template&id=40a55a28&"
import script from "./App.vue?vue&type=script&async=true&lang=js&"
export * from "./App.vue?vue&type=script&async=true&lang=js&"
import style0 from "./App.vue?vue&type=style&index=0&id=40a55a28&prod&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports